<template>
  <div>

    <titulo-list-add-new
      :is-add-new-titulo-sidebar-active.sync="isAddNewTituloSidebarActive"
      :situacao-options="statusOptions"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <titulo-list-filters
      :status-filter.sync="statusFilter"
      :status-options="statusOptions"
      :data-baixa-inicial-filter.sync="dataBaixaInicialFilter"
      :data-baixa-final-filter.sync="dataBaixaFinalFilter"
    />

    <!-- Export Card -->
    <b-card
      v-if="statusFilter === 'baixado' || statusFilter === 'todos'"
      class="mb-3"
    >
      <div class="demo-inline-spacing">
        <b-button
          variant="outline-success"       
          @click="exportTitulos('xlsx')"   
        >
          Exportar Excel
          <feather-icon
            icon="DownloadIcon"
            class="ml-50"
          />
        </b-button>
        <b-button
          variant="outline-info"       
          @click="exportTitulos('csv')"   
        >
          Exportar CSV
          <feather-icon
            icon="DownloadIcon"
            class="ml-50"
          />
        </b-button>
      </div>
    </b-card>

    <!-- <b-card
      class=""
    >
      <div class="demo-inline-spacing">
         <b-button
          variant="success"       
          @click="markPaidTitles"   
        >
          Marcar títulos selecionados como pago
          <feather-icon
            icon="CheckIcon"
            class="ml-50"
          />
        </b-button>
      </div>
    </b-card> -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>registros</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Procurar..."
              />
              <!-- <b-button
                variant="primary"
                @click="isAddNewTituloSidebarActive = true"
              >
                <span class="text-nowrap">Adicionar Titulo</span>
              </b-button> -->
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refTituloListTable"
        class="position-relative"
        responsive
        striped
        hover
        :items="fetchTitulos"
        :fields="tableColumns"  
        primary-key="id"
        show-empty
        empty-text="Nenhum registro encontrado"
      >

        <!-- <template #cell(#)="data">
          <b-form-checkbox
            v-model="selected"
            :value="data.item.id"
            class="custom-control-primary"
          >              
          </b-form-checkbox>
        </template> -->

        <!-- Column: User -->
        <template #cell(nome)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :text="avatarText(data.item.nome)"
                variant="light-danger"

              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap" 
            >
              {{ data.item.nome }}
            </b-link>
          </b-media>
        </template>

        <!-- Column: Credor -->
        <template #cell(credor)="data">
          <span class="font-weight-bolder">{{ data.item.credor }}</span>
        </template>

        <!-- Column: Status -->
        <template #cell(situacao)="data">
          <b-badge
            pill
            :variant="`light-${resolveTituloStatusVariant(data.item.situacao)}`"
            class="text-capitalize"
          >
            {{ resolveTituloStatusText(data.item.situacao) }}
          </b-badge>
        </template>

        <!-- Column: Data Baixa -->
        <template #cell(data_baixa)="data">
          <span v-if="data.item.data_baixa">
            {{ data.item.data_baixa }}
          </span>
          <span v-else class="text-muted">-</span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button
            size="sm"
            variant="outline-success"
            @click="confirmarPgtoTitulo(data.item.id)"
            v-if="data.item.situacao != 'BAIXADO'"
          >
            Informar pgto.
            <feather-icon
              icon="CheckIcon"
              class="ml-50"
            />
          </b-button>
          <span v-else>-</span>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Exibindo de {{ dataMeta.from }} até {{ dataMeta.to }} de {{ dataMeta.total }} registros</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="dataMeta.total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted, computed} from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import TituloListFilters from './TituloListFilters.vue'
import TituloListAddNew from './TituloListAddNew.vue'
import useTituloList from './useTituloList'
import tituloStoreModule from '../tituloStoreModule'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@axios'

export default {
  components: {
    TituloListFilters,
    TituloListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,

    vSelect,
  },
  setup() {
    const TITULO_APP_STORE_MODULE_NAME = 'app-titulo'

    // Register module
    if (!store.hasModule(TITULO_APP_STORE_MODULE_NAME)) store.registerModule(TITULO_APP_STORE_MODULE_NAME, tituloStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(TITULO_APP_STORE_MODULE_NAME)) store.unregisterModule(TITULO_APP_STORE_MODULE_NAME)
    })

    const isAddNewTituloSidebarActive = ref(false)

    const selected  = ref([])

    function markPaidTitles(){
      if(this.selected.length > 0){
        axios.post('pagamento/titulos', 
          {
            'titulos' : this.selected,
          }
        ).then((response) => {
          console.log()
          this.$refs.refTituloListTable.refresh();
          selected.value = []
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Pagamento de títulos',
              icon: 'FileIcon',
              variant: 'success',
              text: `Títulos pagos com sucesso!`,
            },
          })
        }).catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Pagamento de títulos',
              icon: 'FileIcon',
              variant: 'danger',
              text: `Não conseguimos marcar seus títulos como pagos ):`,
            },
          })
        });
      }else{
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Pagamento de títulos',
            icon: 'FileIcon',
            variant: 'danger',
            text: `Selecione ao menos um título.`,
          },
        })
      }      
    }

    function confirmarPgtoTitulo(id) {
      this.$bvModal
        .msgBoxConfirm('Você deseja confirmar o pagamento?', {
          title: 'Confirme sua ação',
          size: 'sm',
          modalClass: 'modal-success',
          okVariant: 'success',
          okTitle: 'Sim, confirmar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if(value == true){
            axios.put('api-credor/'+id+'/informarPagamento',{
              situacao: 'BAIXADO'
            })
            .then((response) => {
              this.$refs.refTituloListTable.refresh();
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Pagamento de título',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: `Pagamento informado com sucesso!`,
                },
              })
            }).catch(error => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Pagamento de título',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: `Algo deu errado ):`,
                },
              })
            });
          }
        })
    }

    const {
      fetchTitulos,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      refTituloListTable,
      refetchData,
      exportTitulos,

      // UI
      resolveTituloStatusVariant,
      resolveTituloStatusText,

      // Extra Filters
      statusFilter,
      dataBaixaInicialFilter,
      dataBaixaFinalFilter,
    } = useTituloList()

    const statusOptions = [
      { label: 'Ativos', value: 'ativo' },
      { label: 'Baixados', value: 'baixado' },
      { label: 'Todos', value: 'todos' }
    ]

    return {

      // Sidebar
      isAddNewTituloSidebarActive,

      fetchTitulos,
      tableColumns,
      perPage,
      currentPage,
      dataMeta,
      perPageOptions,
      searchQuery,
      refTituloListTable,
      refetchData,
      exportTitulos,

      // Filter
      selected,
      markPaidTitles,
      confirmarPgtoTitulo,
      avatarText,

      // UI
      resolveTituloStatusVariant,
      resolveTituloStatusText,

      statusOptions,

      // Extra Filters
      statusFilter,
      dataBaixaInicialFilter,
      dataBaixaFinalFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
